import { render } from "./iconButton.vue?vue&type=template&id=e4ae8884&scoped=true"
import script from "./iconButton.vue?vue&type=script&lang=js"
export * from "./iconButton.vue?vue&type=script&lang=js"

import "./iconButton.vue?vue&type=style&index=0&id=e4ae8884&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ae8884"]])

export default __exports__